<template>
	<div ng-if="overlayController" class="windowOverlay" id="upgradeChampion" ng-controller="overlayController">
	<div class="darkener clickable" clickable="closeOverlay()"></div>
	<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="284" style="max-height: none;"><div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
	<div class="inWindowPopupHeader">
		<!-- ngIf: overlayConfig['inWindowPopupTitle'] != '' --><h4 translate="" options="Champion.Upgrade.Title" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Улучшить чемпиона</span></h4><!-- end ngIf: overlayConfig['inWindowPopupTitle'] != '' -->
		<!-- ngIf: overlayConfig['inWindowPopupTitleText'] != '' --><h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4><!-- end ngIf: overlayConfig['inWindowPopupTitleText'] != '' -->
		<a class="closeOverlay clickable" clickable="closeOverlay()" translate="" @click="gameModel.champions.upgradeChampionShow = false"><span>Закрыть</span></a>
	</div>
	<div class="inWindowPopupContent">
		<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']"><div class="useItem upgradeChampion">
	<div class="contentBox">
		<div class="contentBoxHeader headerWithArrowDown" translate=""><span>Увеличить эффект бонуса</span></div>
		<div class="contentBoxBody">
			<div class="itemContainer">
				<div class="entityBox noClick heroItem_tabletStone_large_illu"></div>
				<div class="verticalLine"></div>
				<div class="description" translate=""><span>Чемпионы могут быть улучшены до 3 раз. Каждое состояние связано с уровнем предметов игрового мира. Используя эту скрижаль, вы сможете повысить уровень своего чемпиона в рамках данного игрового мира. Пожалуйста, выберите чемпиона, которого хотите улучшить.</span></div>
			</div>

			<div class="horizontalLine"></div>

			<div class="championSelection" champions="champions" selected-champion="selectedChampion" disable-maxed="true" show-proficiency="true">
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionFrom clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion(true)"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
	<div scrollable="" horizontal="" scroll-duration="300" class="scrollable" style="overflow-y: hidden;"><div class="scrollContentOuterWrapper active" style="height: 88px;">
	<div class="scrollContent" dynamic-height="false" style="height: 103px; overflow-x: auto;">
		<div class="scrollContentInnerWrapper" ng-transclude="" style="white-space: nowrap; height: 88px;">
		<!-- ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage caesar rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage cleopatra rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable active" clickable="changeChampion(index)">
			<div class="championProfileImage vercingetorix rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency2"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage edithe rarity1">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage incitatus rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage arleno rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage galen rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage teutobod rarity3">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions -->
	</div>
	</div>
</div>
<div class="scrollTrack horizontal" style="opacity: 1; display: block;">
    <div class="scrollHandle" style="left: 0px; width: 369.014px;"></div>
	<div class="trackDecoration"></div>
</div></div>
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionTo clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion()"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
</div>
			<div class="championName"><!-- ngIf: champions[selectedChampion] --><span translate="" ng-if="champions[selectedChampion]" options="vercingetorix"><span>Верцингеторикс</span></span><!-- end ngIf: champions[selectedChampion] --></div>

			<div class="horizontalLine"></div>

			<div class="calculationContainer">
				<div class="itemWrapper">
					<div class="entityBox noClick" ng-class="{empty: !champions[selectedChampion]}">
						<!-- ngIf: champions[selectedChampion] --><div ng-if="champions[selectedChampion]" class="championProfileImage vercingetorix">
							<div class="championLevel proficiency2"></div>
						</div><!-- end ngIf: champions[selectedChampion] -->
					</div>
				</div>
				<div class="plusCircled"></div>
				<div class="itemWrapper">
					<div class="entityBox noClick heroItem_tabletStone_large_illu"></div>
					<!-- ngIf: availableTablets --><span ng-if="availableTablets" class="resourceValue" ng-bind-html="0 | bidiRatio : 1 : availableTablets[champions[selectedChampion] ? champions[selectedChampion].data.level : (w.params.championLvl || 0)]" ng-class="{warning: !availableTablets[champions[selectedChampion] ? champions[selectedChampion].data.level : (w.params.championLvl || 0)]}">&lrm;&lrm;&#x202D;&#x202D;&#x202D;&#x202D;1&#x202C;&#x202C;&#x202C;&#x202C;/&lrm;&#x202D;&#x202D;&#x202D;&#x202D;1&#x202C;&#x202C;&#x202C;&#x202C;</span><!-- end ngIf: availableTablets -->
				</div>
				<div class="equalCircled"></div>
				<div class="itemWrapper">
					<div class="entityBox noClick" ng-class="{empty: !champions[selectedChampion]}">
						<!-- ngIf: champions[selectedChampion] --><div ng-if="champions[selectedChampion]" class="championProfileImage vercingetorix">
							<div class="championLevel proficiency3"></div>
						</div><!-- end ngIf: champions[selectedChampion] -->
					</div>
				</div>
			</div>

			<div class="horizontalLine"></div>

			<div class="upgradeMessage">
				<!-- ngIf: getCurrentTier() >= champions[selectedChampion].data.level + 1 && champions[selectedChampion] --><!-- end ngIf: getCurrentTier() >= champions[selectedChampion].data.level + 1 && champions[selectedChampion] -->
				<!-- ngIf: getCurrentTier() < champions[selectedChampion].data.level + 1 --><span translate="" ng-if="getCurrentTier() &lt; champions[selectedChampion].data.level + 1" class="warning" data="tier:3"><span>Применить этот предмет можно лишь с наступлением эпохи: 3 </span></span><!-- end ngIf: getCurrentTier() < champions[selectedChampion].data.level + 1 -->
			</div>
		</div>
	</div>

	<div class="buttonBar">
		<button clickable="upgradeChampion(selectedChampion)" ng-class="{disabled: !champions[selectedChampion] || !availableTablets[champions[selectedChampion].data.level] || getCurrentTier() &lt; champions[selectedChampion].data.level + 1}" class="clickable disabled"><div class="content">
	<span ng-transclude="" class="innerText">
			<span translate=""><span>Улучшить</span></span>
		</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
		<span>
			<button clickable="closeOverlay()" class="cancel clickable" @click="gameModel.champions.upgradeChampionShow = false"><div class="content">
	<span ng-transclude="" class="innerText">
				<span translate=""><span>Отмена</span></span>
			</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
		</span>
	</div>
</div>
</div>
	</div>
</div></div>
</div>








<div ng-if="overlayController" class="windowOverlay" id="upgradeChampion" ng-controller="overlayController">
	<div class="darkener clickable" clickable="closeOverlay()"></div>
	<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="284" style="max-height: none;"><div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
	<div class="inWindowPopupHeader">
		<!-- ngIf: overlayConfig['inWindowPopupTitle'] != '' --><h4 translate="" options="Champion.Upgrade.Title" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Улучшить чемпиона</span></h4><!-- end ngIf: overlayConfig['inWindowPopupTitle'] != '' -->
		<!-- ngIf: overlayConfig['inWindowPopupTitleText'] != '' --><h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4><!-- end ngIf: overlayConfig['inWindowPopupTitleText'] != '' -->
		<a class="closeOverlay clickable" clickable="closeOverlay()" translate="" @click="gameModel.champions.upgradeChampionShow = false"><span>Закрыть</span></a>
	</div>
	<div class="inWindowPopupContent">
		<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']"><div class="useItem upgradeChampion">
	<div class="contentBox">
		<div class="contentBoxHeader headerWithArrowDown" translate=""><span>Увеличить эффект бонуса</span></div>
		<div class="contentBoxBody">
			<div class="itemContainer">
				<div class="entityBox noClick heroItem_tabletClay_large_illu"></div>
				<div class="verticalLine"></div>
				<div class="description" translate=""><span>Чемпионы могут быть улучшены до 3 раз. Каждое состояние связано с уровнем предметов игрового мира. Используя эту скрижаль, вы сможете повысить уровень своего чемпиона в рамках данного игрового мира. Пожалуйста, выберите чемпиона, которого хотите улучшить.</span></div>
			</div>

			<div class="horizontalLine"></div>

			<div class="championSelection" champions="champions" selected-champion="selectedChampion" disable-maxed="true" show-proficiency="true">
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionFrom clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion(true)"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
	<div scrollable="" horizontal="" scroll-duration="300" class="scrollable" style="overflow-y: hidden;"><div class="scrollContentOuterWrapper active" style="height: 88px;">
	<div class="scrollContent" dynamic-height="false" style="height: 103px; overflow-x: auto;">
		<div class="scrollContentInnerWrapper" ng-transclude="" style="white-space: nowrap; height: 88px;">
		<!-- ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage caesar rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage cleopatra rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage vercingetorix rarity0">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency2"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable active" clickable="changeChampion(index)">
			<div class="championProfileImage edithe rarity1">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage incitatus rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage arleno rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage galen rarity2">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage teutobod rarity3">
				<!-- ngIf: ::showProficiency --><div ng-if="::showProficiency" class="championLevel proficiency0"></div><!-- end ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions -->
	</div>
	</div>
</div>
<div class="scrollTrack horizontal" style="opacity: 1; display: block;">
    <div class="scrollHandle" style="left: 32.8012px; width: 369.014px;"></div>
	<div class="trackDecoration"></div>
</div></div>
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionTo clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion()"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
</div>
			<div class="championName"><!-- ngIf: champions[selectedChampion] --><span translate="" ng-if="champions[selectedChampion]" options="edithe"><span>Эдит</span></span><!-- end ngIf: champions[selectedChampion] --></div>

			<div class="horizontalLine"></div>

			<div class="calculationContainer">
				<div class="itemWrapper">
					<div class="entityBox noClick" ng-class="{empty: !champions[selectedChampion]}">
						<!-- ngIf: champions[selectedChampion] --><div ng-if="champions[selectedChampion]" class="championProfileImage edithe">
							<div class="championLevel proficiency0"></div>
						</div><!-- end ngIf: champions[selectedChampion] -->
					</div>
				</div>
				<div class="plusCircled"></div>
				<div class="itemWrapper">
					<div class="entityBox noClick heroItem_tabletClay_large_illu"></div>
					<!-- ngIf: availableTablets --><span ng-if="availableTablets" class="resourceValue" ng-bind-html="0 | bidiRatio : 1 : availableTablets[champions[selectedChampion] ? champions[selectedChampion].data.level : (w.params.championLvl || 0)]" ng-class="{warning: !availableTablets[champions[selectedChampion] ? champions[selectedChampion].data.level : (w.params.championLvl || 0)]}">&lrm;&lrm;&#x202D;&#x202D;&#x202D;&#x202D;1&#x202C;&#x202C;&#x202C;&#x202C;/&lrm;&#x202D;&#x202D;&#x202D;&#x202D;2&#x202C;&#x202C;&#x202C;&#x202C;</span><!-- end ngIf: availableTablets -->
				</div>
				<div class="equalCircled"></div>
				<div class="itemWrapper">
					<div class="entityBox noClick" ng-class="{empty: !champions[selectedChampion]}">
						<!-- ngIf: champions[selectedChampion] --><div ng-if="champions[selectedChampion]" class="championProfileImage edithe">
							<div class="championLevel proficiency1"></div>
						</div><!-- end ngIf: champions[selectedChampion] -->
					</div>
				</div>
			</div>

			<div class="horizontalLine"></div>

			<div class="upgradeMessage">
				<!-- ngIf: getCurrentTier() >= champions[selectedChampion].data.level + 1 && champions[selectedChampion] --><span translate="" ng-if="getCurrentTier() &gt;= champions[selectedChampion].data.level + 1 &amp;&amp; champions[selectedChampion]" options="edithe" data="bonus:-10"><span>&#x202D;-&#x202D;10&#x202C;%&#x202C; потребление зерна</span></span><!-- end ngIf: getCurrentTier() >= champions[selectedChampion].data.level + 1 && champions[selectedChampion] --><!-- end ngIf: getCurrentTier() >= champions[selectedChampion].data.level + 1 && champions[selectedChampion] -->
				<!-- ngIf: getCurrentTier() < champions[selectedChampion].data.level + 1 --><!-- end ngIf: getCurrentTier() < champions[selectedChampion].data.level + 1 -->
			</div>
		</div>
	</div>

	<div class="buttonBar">
		<button clickable="upgradeChampion(selectedChampion)" ng-class="{disabled: !champions[selectedChampion] || !availableTablets[champions[selectedChampion].data.level] || getCurrentTier() &lt; champions[selectedChampion].data.level + 1}" class="clickable"><div class="content">
	<span ng-transclude="" class="innerText">
			<span translate=""><span>Улучшить</span></span>
		</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
		<span>
			<button clickable="closeOverlay()" class="cancel clickable" @click="gameModel.champions.upgradeChampionShow = false"><div class="content">
	<span ng-transclude="" class="innerText">
				<span translate=""><span>Отмена</span></span>
			</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
		</span>
	</div>
</div>
</div>
	</div>
</div></div>
</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>
